<div #reportHtml class="report">
  <kendo-pdf-export
    id="pdfExport"
    #pdf
    [margin]="margins"
    [scale]="0.6"
    forcePageBreak=".page-break"
    [landscape]="false"
  >
    <ng-template
      kendoPDFTemplate
      let-pageNum="pageNum"
      let-totalPages="totalPages"
    >
      <div class="pdfHeader">Page {{ pageNum }} of {{ totalPages }}</div>

      <div class="pdfBranding">
        <img height="40" src="/assets/brand/intel-logo-{{ theme() }}.svg" />
      </div>

      <div class="pdfFooter">
        <img src="/assets/brand/intel-bug-{{ theme() }}.svg" />
        <span
          ><strong
            ><a
              href="https://intel471.com/titan/threat-hunt-intelligence"
              target="_blank"
              >Intel 471 Threat Hunting Module</a
            ></strong
          ></span
        >
      </div>
      <!-- test -->
    </ng-template>
    <div class="header">
      <div>
        <hyperkit-typography
          class="title"
          display="inline"
          variant="h2"
          align="left"
          color="primary"
          >Hunt Module Dashboard</hyperkit-typography
        >
        <span class="date-ranges">
          <kendo-buttongroup selection="single">
            @for (presetFilter of presetFilters; track presetFilter) {
              <button
                kendoButton
                (click)="applyPresetFilter(presetFilter)"
                [toggleable]="true"
                [selected]="isDateRangeSelected(presetFilter)"
                title="Bold"
                color="primary"
              >
                {{ presetFilter }}
              </button>
            }
            <button
              kendoButton
              #anchor
              [selected]="isDateRangeSelected(customFilter)"
              [toggleable]="true"
              color="primary"
              (click)="popup.toggle()"
            >
              Custom
            </button>
          </kendo-buttongroup>
          <kendo-daterange-popup
            [anchor]="{ nativeElement: anchor ? anchor.nativeElement : null }"
            #popup
          >
            <ng-template kendoDateRangePopupTemplate>
              <kendo-multiviewcalendar #calendar kendoDateRangeSelection>
              </kendo-multiviewcalendar>
              <div>
                <hyperkit-button
                  size="small"
                  (click)="cancelCustomDate()"
                  variant="standard"
                  color="secondary"
                  text="Cancel"
                ></hyperkit-button>
                <hyperkit-button
                  size="small"
                  [disabled]="calendar.selectionRange?.start == null"
                  (click)="applyCustomDate()"
                  variant="standard"
                  color="tertiary"
                  text="Apply"
                ></hyperkit-button>
              </div>
            </ng-template>
          </kendo-daterange-popup>
        </span>
      </div>
      <div class="no-export button-container">
        <hyperkit-button
          size="small"
          (click)="exportDashboard()"
          variant="standard"
          color="secondary"
          icon="download"
          text="Export"
        ></hyperkit-button>
        <hyperkit-button
          size="small"
          id="toggleFilters"
          (click)="filterPanel.toggleFilterPanel()"
          variant="standard"
          color="tertiary"
          text="Filters"
        ></hyperkit-button>

        <dashboard-filter #filterPanel></dashboard-filter>
      </div>
    </div>
    @if (state && state?.filter.filters.length > 0) {
      <div id="filters" class="filter-chip-wrapper">
        @for (filter of state.filter.filters; track filter) {
          <span>
            @if (notDateFilter(getField(filter))) {
              <span>
                @if (isMultiSelectFilter(filter)) {
                  @for (value of filter.value; track value) {
                    <hyperkit-button
                      size="small"
                      (click)="removeFilter(filter, value)"
                      variant="standard"
                      color="secondary"
                      iconPosition="right"
                      icon="x"
                      text="{{ getFilterLabel(getField(filter), value) }}"
                    ></hyperkit-button>
                  }
                } @else {
                  <hyperkit-button
                    size="small"
                    (click)="removeFilter(filter, filter.value)"
                    variant="standard"
                    color="secondary"
                    iconPosition="right"
                    icon="x"
                    text="{{
                      getFilterLabelSingle(getField(filter), filter.value)
                    }}"
                  ></hyperkit-button>
                }
              </span>
            }
          </span>
        }
        @if (state.presetDateFilter === customFilter) {
          <kendo-chip
            [label]="getCustomDateFilterLabel()"
            themeColor="info"
            [removable]="true"
            (remove)="applyPresetFilter(presetDateFilters.CURRENT_MONTH)"
          >
          </kendo-chip>
        }
      </div>
    }
    <div id="overview" class="overview outer-section">
      <div class="section-title">
        <hyperkit-typography
          display="inline"
          variant="h4"
          align="left"
          color="primary"
          >Overview</hyperkit-typography
        >
      </div>
      <div class="outer-wrapper">
        <div class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="secondary"
              >Assigned Hunts</hyperkit-typography
            >
            <!-- Assigned Hunts -->
          </div>
          <div class="block-number">
            <span
              [ngClass]="{
                'fade-in': (myAssignedHunts$ | async) && !isExporting,
              }"
            >
              <hyperkit-typography
                display="inline"
                variant="h1"
                align="left"
                color="primary"
              >
                {{
                  (myAssignedHunts$ | async)?.results[0]?.count
                }}</hyperkit-typography
              >
            </span>
          </div>
          <div class="block-subtitle"></div>
          <div style="width: 100%; height: 150px"></div>
        </div>
        <div class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="secondary"
              >Total Hunts</hyperkit-typography
            >
            <!-- Total Hunts -->
          </div>
          <div class="block-number">
            <span
              [ngClass]="{ 'fade-in': (huntCount$ | async) && !isExporting }"
            >
              <hyperkit-typography
                display="inline"
                variant="h1"
                align="left"
                color="primary"
              >
                {{ (huntCount$ | async)?.count }}</hyperkit-typography
              >
              <!-- {{ (huntCount$ | async)?.count }} -->
            </span>
          </div>
          <div class="block-subtitle"></div>
          <div style="width: 100%; height: 150px"></div>
        </div>
        <div class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="secondary"
            >
              Unique Packages</hyperkit-typography
            >
            <!-- Unique Packages -->
          </div>
          <div class="block-number">
            <span
              [ngClass]="{
                'fade-in': (uniquePackageCount$ | async) && !isExporting,
              }"
            >
              <hyperkit-typography
                display="inline"
                variant="h1"
                align="left"
                color="primary"
              >
                {{ (uniquePackageCount$ | async)?.count }}</hyperkit-typography
              >
              <!-- {{ (uniquePackageCount$ | async)?.count }} -->
            </span>
          </div>
          <div class="block-subtitle">
            <hyperkit-typography
              display="inline"
              variant="body"
              size="sm"
              align="left"
              color="body"
            >
              of {{ searchQuery?.count?.cyborg_hunt_packages }} in
              HUNTER</hyperkit-typography
            >
          </div>
          <div style="width: 100%; height: 150px"></div>
        </div>
        <div class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="secondary"
              >Total Packages</hyperkit-typography
            >
            <!-- Total Packages -->
          </div>
          <div class="block-number">
            @if (totalPackageCount$ | async; as totalPackageCount) {
              <span
                [ngClass]="{ 'fade-in': totalPackageCount && !isExporting }"
              >
                <hyperkit-typography
                  display="inline"
                  variant="h1"
                  align="left"
                  color="primary"
                >
                  {{ totalPackageCount?.count }}</hyperkit-typography
                >
                <!-- {{ totalPackageCount?.count }} -->
              </span>
            }
          </div>
          <div class="block-subtitle">
            <hyperkit-typography
              display="inline"
              variant="body"
              size="sm"
              align="left"
              color="body"
            >
              Includes duplicates</hyperkit-typography
            >
          </div>
          <div style="width: 100%; height: 150px"></div>
        </div>
        <div class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="secondary"
              >Actor Coverage</hyperkit-typography
            >
          </div>
          <div class="block-number">
            @if (huntActorCoverage$ | async; as huntActorCoverage) {
              <span
                [ngClass]="{ 'fade-in': huntActorCoverage && !isExporting }"
              >
                <hyperkit-typography
                  display="inline"
                  variant="h1"
                  align="left"
                  color="primary"
                >
                  {{ huntActorCoverage?.results?.length }}</hyperkit-typography
                >
              </span>
            }
          </div>
          <div class="block-subtitle">
            <hyperkit-typography
              display="inline"
              variant="body"
              size="sm"
              align="left"
              color="body"
            >
              of {{ tagSearch?.actors?.length }} in HUNTER</hyperkit-typography
            >
          </div>
          <div style="width: 100%; height: 150px"></div>
        </div>
        <div class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="secondary"
              >Threat Coverage</hyperkit-typography
            >
          </div>
          <div class="block-number">
            @if (huntThreatCoverage$ | async; as huntThreatCoverage) {
              <span
                [ngClass]="{ 'fade-in': huntThreatCoverage && !isExporting }"
              >
                <hyperkit-typography
                  display="inline"
                  variant="h1"
                  align="left"
                  color="primary"
                >
                  {{ huntThreatCoverage?.results?.length }}</hyperkit-typography
                >
              </span>
            }
          </div>
          <div class="block-subtitle">
            <hyperkit-typography
              display="inline"
              variant="body"
              size="sm"
              align="left"
              color="body"
            >
              of {{ tagSearch?.threat_names?.length }} in
              HUNTER</hyperkit-typography
            >
          </div>
          <div style="width: 100%; height: 150px"></div>
        </div>
        <div class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="emphasized"
              size="sm"
              align="left"
              color="secondary"
              >MITRE Techniques</hyperkit-typography
            >
          </div>
          <div class="block-number">
            @if (huntMITRECoverage$ | async; as huntMITRECoverage) {
              <span
                [ngClass]="{ 'fade-in': huntMITRECoverage && !isExporting }"
              >
                <hyperkit-typography
                  display="inline"
                  variant="h1"
                  align="left"
                  color="primary"
                >
                  {{ huntMITRECoverage?.results?.length }}</hyperkit-typography
                >
              </span>
            }
          </div>
          <div class="block-subtitle">
            <hyperkit-typography
              display="inline"
              variant="body"
              size="sm"
              align="left"
              color="body"
            >
              of {{ tagSearch?.mitre_technique_ids?.length }} in
              HUNTER</hyperkit-typography
            >
          </div>
          <div style="width: 100%; height: 150px"></div>
        </div>
      </div>
    </div>
    <div id="coverage" class="coverage outer-section">
      <div class="section-title">
        <hyperkit-typography
          display="inline"
          variant="h4"
          align="left"
          color="primary"
          >Coverage</hyperkit-typography
        >
      </div>
      <div class="outer-wrapper">
        <div id="top-mitre-techniques" class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="h5"
              align="left"
              color="primary"
              >Top MITRE</hyperkit-typography
            >
          </div>
          <div
            id="top-mitre-container"
            style="width: 100%; height: 450px"
          ></div>
          @if (huntMITRECoverage$ | async; as huntMITRECoverage) {
            <div style="width: 100%">
              <table id="mitre-table" class="coverage-table">
                <thead>
                  <tr>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >Technique</hyperkit-typography
                      >
                    </th>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >Tactic</hyperkit-typography
                      >
                    </th>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >Hunts</hyperkit-typography
                      >
                    </th>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >Packages</hyperkit-typography
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    mitre of huntMITRECoverage.results | slice: 0 : 10;
                    track mitre;
                    let i = $index
                  ) {
                    <tr>
                      <td>
                        <hyperkit-link
                          (click)="
                            setSearchStateAndNavigate(
                              tagTypes.MITRE_TECHNIQUE_IDS,
                              mitre.name
                            )
                          "
                          variant="emphasized"
                          size="sm"
                          color="primary"
                          text=" {{ mitre.name }}"
                        >
                        </hyperkit-link>
                      </td>
                      <td>
                        <hyperkit-typography
                          display="inline"
                          variant="body"
                          size="md"
                          align="left"
                          color="body"
                          >{{ mitre?.category }}</hyperkit-typography
                        >
                      </td>
                      <td class="link" (click)="setHuntStateId(mitre?.hunts)">
                        <hyperkit-link
                          variant="emphasized"
                          size="sm"
                          color="primary"
                          text=" {{ mitre.huntCount }}"
                        >
                        </hyperkit-link>
                      </td>
                      <td>
                        <hyperkit-typography
                          display="inline"
                          variant="body"
                          size="md"
                          align="left"
                          color="body"
                        >
                          {{ mitre.huntPackageCount }}</hyperkit-typography
                        >
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
        <div id="top-threats" class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="h5"
              align="left"
              color="primary"
              >Top Threats</hyperkit-typography
            >
          </div>
          <div
            id="top-threats-container"
            style="width: 100%; height: 450px"
          ></div>
          @if (huntThreatCoverage$ | async; as huntThreatCoverage) {
            <div>
              <table id="threat-table" class="coverage-table">
                <thead>
                  <tr>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                      >
                        Name</hyperkit-typography
                      >
                    </th>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                      >
                        Hunts</hyperkit-typography
                      >
                    </th>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                      >
                        Packages</hyperkit-typography
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    threat of huntThreatCoverage.results | slice: 0 : 10;
                    track threat;
                    let i = $index
                  ) {
                    <tr>
                      <td
                        class="link"
                        (click)="
                          setSearchStateAndNavigate(
                            tagTypes.THREAT_NAMES,
                            threat.name
                          )
                        "
                      >
                        <hyperkit-link
                          variant="emphasized"
                          size="sm"
                          color="primary"
                          text=" {{ threat.name }}"
                        >
                        </hyperkit-link>
                      </td>
                      <td class="link" (click)="setHuntStateId(threat?.hunts)">
                        <hyperkit-link
                          variant="emphasized"
                          size="sm"
                          color="primary"
                          text=" {{ threat.huntCount }}"
                        >
                        </hyperkit-link>
                      </td>
                      <td>
                        <hyperkit-typography
                          display="inline"
                          variant="body"
                          size="md"
                          align="left"
                          color="body"
                        >
                          {{ threat.huntPackageCount }}</hyperkit-typography
                        >
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
        <div id="top-actors" class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="h5"
              align="left"
              color="primary"
              >Top Actors</hyperkit-typography
            >
          </div>
          <div
            id="top-actors-container"
            style="width: 100%; height: 450px"
          ></div>
          @if (huntActorCoverage$ | async; as huntActorCoverage) {
            <div>
              <table id="actor-table" class="coverage-table">
                <thead>
                  <tr>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >Name</hyperkit-typography
                      >
                    </th>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >Origin</hyperkit-typography
                      >
                    </th>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >Hunts</hyperkit-typography
                      >
                    </th>
                    <th>
                      <hyperkit-typography
                        display="inline"
                        variant="emphasized"
                        size="sm"
                        align="left"
                        color="primary"
                        >Packages</hyperkit-typography
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    actor of huntActorCoverage.results | slice: 0 : 10;
                    track actor;
                    let i = $index
                  ) {
                    <tr>
                      <td
                        class="link"
                        (click)="
                          setSearchStateAndNavigate(tagTypes.ACTORS, actor.name)
                        "
                      >
                        <hyperkit-link
                          variant="emphasized"
                          size="sm"
                          color="primary"
                          text=" {{ actor?.name }}"
                        >
                        </hyperkit-link>
                      </td>
                      <td>
                        <hyperkit-typography
                          display="inline"
                          variant="body"
                          size="md"
                          align="left"
                          color="body"
                          >{{ actor?.category }}</hyperkit-typography
                        >
                      </td>
                      <td class="link" (click)="setHuntStateId(actor?.hunts)">
                        <hyperkit-link
                          variant="emphasized"
                          size="sm"
                          color="primary"
                          text=" {{ actor?.huntCount }}"
                        >
                        </hyperkit-link>
                      </td>
                      <td>
                        <hyperkit-typography
                          display="inline"
                          variant="body"
                          size="md"
                          align="left"
                          color="body"
                          >{{ actor?.huntPackageCount }}</hyperkit-typography
                        >
                        <!-- {{ actor?.huntPackageCount }} -->
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    </div>
    <div id="mitre-heatmap" class="mitre outer-section">
      <div class="section-title">
        <hyperkit-typography
          display="inline"
          variant="h4"
          align="left"
          color="primary"
          >MITRE Gap Analysis</hyperkit-typography
        >
        <hyperkit-toggle
          labelLeft="Show all"
          [isChecked]="showAllMITREToggleSubject | async"
          (changed)="showAllMITREToggleSubject.next($event)"
        >
        </hyperkit-toggle>
      </div>
      <div class="outer-wrapper">
        <div class="inner-block">
          <div class="chart-container" style="margin: 0px 25px 25px 25px">
            <div
              id="mitre-heatmap-container"
              style="width: 100%; height: 800px"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div id="metrics" class="metrics outer-section">
      <div class="section-title">
        <hyperkit-typography
          display="inline"
          variant="h4"
          align="left"
          color="primary"
          >Metrics</hyperkit-typography
        >
      </div>
      <div class="outer-wrapper">
        <div id="outcomes" class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="h5"
              align="left"
              color="primary"
              >Outcomes</hyperkit-typography
            >
            <div
              id="outcome-pie-container"
              style="width: 100%; height: 400px"
            ></div>
          </div>
        </div>
        <div id="statuses" class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="h4"
              align="left"
              color="primary"
              >Statuses</hyperkit-typography
            >
            <div
              id="status-pie-container"
              style="width: 100%; height: 400px"
            ></div>
          </div>
        </div>
        <div id="priorities" class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="h4"
              align="left"
              color="primary"
              >Priorities</hyperkit-typography
            >
            <div
              id="priority-pie-container"
              style="width: 100%; height: 400px"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div id="workload-distribution" class="activity outer-section">
      <div class="section-title">
        <hyperkit-typography
          display="inline"
          variant="h4"
          align="left"
          color="primary"
          >Activity</hyperkit-typography
        >
      </div>
      <div class="outer-wrapper">
        <div class="inner-block">
          <div class="block-title">
            <hyperkit-typography
              display="inline"
              variant="h4"
              align="left"
              color="primary"
              >Workload Distribution</hyperkit-typography
            >

            <div class="table-container">
              @if (huntsByAssignee | async; as results) {
                <table id="assignee-table">
                  <thead>
                    <tr>
                      <th>
                        <hyperkit-typography
                          display="inline"
                          variant="emphasized"
                          size="sm"
                          align="left"
                          color="primary"
                          >Assignee</hyperkit-typography
                        >
                      </th>
                      <th>
                        <hyperkit-typography
                          display="inline"
                          variant="emphasized"
                          size="sm"
                          align="left"
                          color="primary"
                          >Distribution</hyperkit-typography
                        >
                      </th>
                      <th>
                        <hyperkit-typography
                          display="inline"
                          variant="emphasized"
                          size="sm"
                          align="left"
                          color="primary"
                          >Hunts</hyperkit-typography
                        >
                      </th>
                      <th>
                        <hyperkit-typography
                          display="inline"
                          variant="emphasized"
                          size="sm"
                          align="left"
                          color="primary"
                          >Hunt Packages</hyperkit-typography
                        >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (assignee of results.results; track assignee) {
                      <tr>
                        <td>
                          <hyperkit-typography
                            display="inline"
                            variant="body"
                            size="md"
                            align="left"
                            color="body"
                          >
                            {{ assignee.firstname }}
                            {{ assignee.lastname }}</hyperkit-typography
                          >
                        </td>
                        <td>
                          <hyperkit-progress-bar
                            [value]="getProgress(assignee.count)"
                          ></hyperkit-progress-bar>
                        </td>
                        <td
                          (click)="setHuntStateAssignee(assignee.id)"
                          class="link"
                        >
                          <hyperkit-link
                            display="inline"
                            variant="emphasized"
                            size="sm"
                            align="left"
                            color="primary"
                            text="{{ assignee.count }}"
                          ></hyperkit-link>
                        </td>
                        <td>
                          <hyperkit-typography
                            display="inline"
                            variant="body"
                            size="md"
                            align="left"
                            color="body"
                            >{{
                              assignee.huntPackageCount
                            }}</hyperkit-typography
                          >
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              } @else {
                No data to display
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </kendo-pdf-export>
</div>
